export default __webpack_public_path__ + "static/media/low.9af346ce.PNG";